import { AddressManager } from '@app/utils/AddressManager'
import { createSelector } from '@app/utils/createSelector'

import type { Address } from '@app/packages/geo/Address'
import { createAddress } from '@app/packages/geo/Address'
import { MAP_AREA_KIND } from '@app/packages/geo/constants'
import type { AddressKind } from '@app/packages/geo/MapBounds'

import { createReduxSlice } from '@app/store/redux_slice'

type LocationState = {
  /** Address that is house */
  house: Address | null
  /** Address that is at least has address */
  address: Address | null
  /** Address that is address or just map area */
  location: Address | null
}

const locationSlice = createReduxSlice<LocationState>('location')

export const updateLocation = (address: Address) =>
  locationSlice.update(state => ({
    house: new AddressManager(address).isHouse() ? address : (state?.house ?? null),
    address: address.kind !== MAP_AREA_KIND ? address : (state?.address ?? null),
    location: address,
  }))

export const locationAnySelector = createSelector([locationSlice.selector], state => state?.location ?? null)
export const locationAnyRequiredSelector = createSelector([locationSlice.selector], state => state?.location || defaultLocation)
export const locationAddressSelector = createSelector([locationSlice.selector], state => state?.address ?? null)
export const locationRequiredAddressSelector = createSelector([locationSlice.selector], state => state?.address || defaultLocation)
export const locationHouseSelector = createSelector([locationSlice.selector], state => state?.house ?? null)

const defaultLocation = createAddress({
  label: 'Россия, Москва, Кремль',
  kind: 'locality' satisfies AddressKind,
  location: {
    lat: 55.755814,
    lon: 37.617635,
  },
  bounds: {
    bottomLeft: { lat: 55.75369958923342, lon: 37.61552058923342 },
    topRight: { lat: 55.75792841076658, lon: 37.61974941076658 },
  },
})
